"use client";

import { Suspense } from "react";
import dynamic from "next/dynamic";
import { ThemeProvider } from "./ThemeProvider";
import StoreProvider from "./StoreProvider";
import AuthProvider from "./AuthProvider";
import { Toaster } from "sonner";
import CartSyncProvider from "@/src/features/cart/components/CartSyncProvider";
import WishlistSyncProvider from "@/src/features/wishlist/components/WishlistSyncProvider";

const HomeNotifications = dynamic(
  () => import("@/src/components/home/HomeNotifications.client"),
  { loading: () => null }
);

const WelcomePointsSection = dynamic(
  () => import("@/src/features/auth/components/WelcomePointsSection.client"),
  { ssr: false, loading: () => null }
);

const toasterClassNames = {
  toast:
    "!relative !z-[2147483647] !overflow-hidden !rounded-2xl !border !border-[#ee376a] !border-l-[5px] !border-l-white !bg-[#ee376a] !px-4 !py-[0.95rem] !text-white !shadow-[0_14px_34px_rgba(238,55,106,0.28)] before:pointer-events-none before:absolute before:inset-0 before:content-[''] before:bg-[linear-gradient(90deg,rgba(255,255,255,0.16)_0%,rgba(255,255,255,0.08)_42%,rgba(255,255,255,0)_100%)] data-[mounted=true]:animate-app-toast-enter-side data-[removed=true]:data-[front=true]:animate-app-toast-exit-side",
  title: "!text-[0.95rem] !font-extrabold !text-white",
  description: "!mt-[0.2rem] !text-[0.84rem] !leading-[1.7] !text-[rgba(255,255,255,0.92)]",
  closeButton:
    "!rounded-full !border !border-[rgba(255,255,255,0.38)] !bg-[rgba(255,255,255,0.14)] !text-white hover:!bg-[rgba(255,255,255,0.22)] hover:!text-white",
  success:
    "!border-[#ee376a] before:bg-[linear-gradient(90deg,rgba(255,255,255,0.16)_0%,rgba(255,255,255,0.08)_42%,rgba(255,255,255,0)_100%)]",
  error:
    "!border-[#ee376a] before:bg-[linear-gradient(90deg,rgba(255,255,255,0.16)_0%,rgba(255,255,255,0.08)_42%,rgba(255,255,255,0)_100%)]",
};

export default function AppProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <StoreProvider>
      <ThemeProvider>
        <AuthProvider>
          <CartSyncProvider>
            <WishlistSyncProvider>
              <Suspense fallback={null}>
                <HomeNotifications />
              </Suspense>
              <Suspense fallback={null}>
                <WelcomePointsSection />
              </Suspense>
              {children}
              <Toaster
                position="top-left"
                closeButton
                visibleToasts={1}
                offset={68}
                toastOptions={{
                  classNames: toasterClassNames,
                }}
              />
            </WishlistSyncProvider>
          </CartSyncProvider>
        </AuthProvider>
      </ThemeProvider>
    </StoreProvider>
  );
}
